import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import axios from 'axios';
import { ApiUrl } from './configuration/apiEndpoints';

// import "@fontsource/inter";
import '@fontsource-variable/noto-sans-sc';

import './i18n'

const theme = createTheme({
  typography: {
    // fontFamily: 'Inter, Arial, sans-serif',
    fontFamily: 'Noto Sans SC Variable, sans-serif',
  },
});

axios.defaults.baseURL = ApiUrl;

axios.interceptors.request.use(
  (config) => {
    var accessToken = localStorage.getItem("accessToken");
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }
    // Only add Authorization header if the request requires it
    if (accessToken && config.requiresAuth !== false) {
      config.headers.Authorization = `Bearer ${accessToken}`;
      config.withCredentials = true;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
